import { render, staticRenderFns } from "./Referencias.vue?vue&type=template&id=1a98c367&scoped=true&lang=html&"
import script from "./Referencias.vue?vue&type=script&lang=js&"
export * from "./Referencias.vue?vue&type=script&lang=js&"
import style0 from "./Referencias.vue?vue&type=style&index=0&id=1a98c367&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98c367",
  null
  
)

export default component.exports